import {createContext, useContext, useEffect} from "react";
import {getContext, take} from "redux-saga/effects";
import {bindActions} from "./store/actions";

export const AppContext = createContext({
    store: null,
    actions: bindActions(null),
    sagaMiddleware: null,
    modal: {},
    readyCh: null, // readyCh is used to indicate that API calls can proceed.
    setBottomBar: (_n) => {},
    setFab: (_n) => {},
    setTrendingToggles: (_n) => {},
});

export const useActions = () => {
    const { actions } = useContext(AppContext);
    return actions;
};

export const useFab = (community) => {
    const { setFab } = useContext(AppContext);
    return useEffect(() => {
        setFab(community);
        return () => setFab(false);
    });
};

export const useTrendingToggles = (state) => {
    const { setTrendingToggles } = useContext(AppContext);
    return useEffect(() => {
        setTrendingToggles(state);
        return () => setTrendingToggles(false);
    });
};

export const useBottomBar = () => {
    const { setBottomBar } = useContext(AppContext);
    return useEffect(() => {
        setBottomBar((n) => n + 1);
        return () => setBottomBar((n) => n - 1);
    });
};

export function* waitUntilReady() {
    const bypassed = yield getContext('ready');
    if (!bypassed) {
        const readyCh = yield getContext('readyCh');
        yield take(readyCh);
    }
}
